// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-cookiebot-crawler-js": () => import("./../../../src/pages/cookiebot-crawler.js" /* webpackChunkName: "component---src-pages-cookiebot-crawler-js" */),
  "component---src-templates-home-base-index-js": () => import("./../../../src/templates/home/base/index.js" /* webpackChunkName: "component---src-templates-home-base-index-js" */),
  "component---src-templates-qrcode-index-js": () => import("./../../../src/templates/qrcode/index.js" /* webpackChunkName: "component---src-templates-qrcode-index-js" */)
}

